import { VueTyper } from 'vue-typer'
import { Slide } from 'vue-burger-menu'

export default {
  name: 'navigation',
  components: {
    VueTyper,
    Slide
  },
  props: [],
  data () {
    return {
      quotes: ['Watch the world grow', 'Feel the world moving', 'Feel the sun on your skin']
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {

  }
}


